import React from "react"
import CurrencyInput from "../../CurrencyInput/CurrencyInput"
import PercentageInput from "../../PercentageInput/PercentageInput"
import NumberInput from "../../NumberInput/NumberInput"
import Switch from '../../Switch/Switch'

class IncidentalDepositBuilderAuthorizationAmount extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return(
      <div>

        <h5 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 10 }}>{`${I18n.t('authorization_amount')}*`}</h5>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <div className="row">
                {this.renderAmount()}
                <div className="col-md-1 flexed content-center">
                  <em>{I18n.t('or')}</em>
                </div>
                {this.renderPercentage()}
                <div className="col-md-1 flexed content-center">
                  <em>{I18n.t('or')}</em>
                </div>
                {this.renderNumberOfNights()}
              </div>
            </div>
          </div>
        </div>

        <br />
        <br />

        <div className="row">
          <div className="form-group">
            {this.renderIncludeReservationBalance()}
          </div>
        </div>

      </div>
    );
  };

  renderIncludeReservationBalance(incidentalDeposit) {
    return(
      <div className="col-md-6">
        <div className="form-group">
          <label>{I18n.t('include_reservation_balance')} <span className="ss-help help" title={I18n.t('include_reservation_balance_helper_text')}></span></label>
          <Switch 
            onText="yes"
            switchId="include-reservation-balance-switch"
            offText="no"
            value={this.props.incidental_deposit.include_reservation_balance} 
            onChange={this.props.onChangeIncludeBalance} 
            />
        </div>
      </div>
    )
  }

  renderAmount() {
    return(
      <div className="col-sm">
        <div>{I18n.t('amount')}</div>
        <CurrencyInput name="incidental_amount" className={this.props.renderFieldClasses('incidental_amount')} value={this.props.incidental_deposit.incidental_amount ? this.props.incidental_deposit.incidental_amount : ""} onChange={this.props.onChangeAmount}  />
        {this.props.renderFieldErrors('incidental_amount')}
      </div>
    )
  }

  renderPercentage() {
    return(
      <div className="col-sm">
        <div>{I18n.t('percentage')} <span className="ss-help help" title={I18n.t('incidental_deposit_percentage_helper_text')}></span></div>
        <PercentageInput name="incidental_percentage" className={this.props.renderFieldClasses('incidental_percentage')} value={this.props.incidental_deposit.incidental_percentage ? this.props.incidental_deposit.incidental_percentage : ""} onChange={this.props.onChangePercentage}/>
        {this.props.renderFieldErrors('incidental_percentage')}
      </div >
    )
  }

  renderNumberOfNights() {
    return(
      <div className="col-sm">
        <div>{I18n.t('number_of_nights')}</div>
          <div className="input-group">
            <NumberInput name="incidental_number_of_nights" value={this.props.incidental_deposit.incidental_nights ? this.props.incidental_deposit.incidental_nights : "" }  className={this.props.renderFieldClasses('incidental_nights')} style={{textAlign: 'right'}} onChange={this.props.onChangeNights} />
            {this.props.renderFieldErrors('incidental_nights')}
          <div className="input-group-append"><span className="input-group-text">{I18n.t('nights')}</span></div>
          </div>
      </div>
    )
  }

}

export default IncidentalDepositBuilderAuthorizationAmount